// Shared BIE API helpers. Adjust import path if your core helper path differs.
import { postBiz, rows, json, fetchCombo, normalizeCombo } from '../core/coreapi';



export const fetchBieScenarioCombo = async () =>
  rows(await fetchCombo('biescenario')).map(normalizeCombo);

export const fetchBieSourceCombo = async () =>
  (await fetchCombo('bievaluesource')).map(normalizeCombo);

export const fetchBiePeriodCombo = async () =>
  (await fetchCombo('bieperiod')).map(normalizeCombo);

export const fetchBieEntityCombo = async () =>
  (await fetchCombo('bieentity')).map(normalizeCombo);

export const fetchBieLocationCombo = async () =>
  (await fetchCombo('bielocation')).map(normalizeCombo);

export const fetchBieAccountCombo = async () =>
  (await fetchCombo('bieaccount')).map(normalizeCombo);

export const fetchBieDriverCombo = async () =>
  (await fetchCombo('biedriver')).map(normalizeCombo);

export const fetchBieEntryTypeCombo = async () =>
  (await fetchCombo('bieentrytype')).map(normalizeCombo);

export const fetchBieDashboardSummary = (scenarioCode: string) =>
  json(postBiz({s: 'biedashboard', a: 'summary', scc: scenarioCode }));

export const fetchBieSimulator = (scenarioCode: string) =>
  json(postBiz({s: 'biesimulator', a: 'get', scc: scenarioCode }));

export const updateBieSlider = (scenarioCode: string, driverCode: string, value: number) =>
  json(postBiz({s: 'bieslider', a: 'update', scc: scenarioCode, drc: driverCode, val: value }));

export const runBieSensitivity = (scenarioCode: string, driverCode: string) =>
  rows(postBiz({s: 'bieanalysis', a: 'sensitivity', scc: scenarioCode, drc: driverCode }));

export const submitBieEntries = (payload: any) =>
  json(postBiz({s: 'bieimport', a: 'console', ...payload}));
